export default __webpack_public_path__ + "static/media/LSP.2bd35739.jpeg";